
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-waiver-disclaimer",
      function () {
        return require("private-next-pages/medical-waiver-disclaimer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-waiver-disclaimer"])
      });
    }
  